import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function PopularComics() {
  const popular = [...comics]
    .sort((a, b) => b.views - a.views)
    .slice(0, 8);

  return (
    <section className="py-14 md:py-18 bg-background-100" aria-label="热门漫画">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">热门漫画</h2>
            <p className="text-sm text-foreground-500 mt-1">大家都在看的漫画</p>
          </div>
          <Link to="/category/全部" className="text-sm text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {popular.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/category/全部"
            className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 border border-background-300 text-foreground-700 rounded-full font-medium text-sm hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
          >
            浏览全部漫画 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}